import { Dialog as DialogPrimitive } from "radix-ui";
import { useTranslation } from "react-i18next";

import { Accordion, AccordionItem } from "~/components/accordion";
import { ContactUsDialog } from "~/components/contact-us-dialog";
import { OrderMultiParcel } from "~/components/order/order-multi-parcel";
import { OrderParcel } from "~/components/order/order-parcel";
import type { OrderQuery } from "~/graphql/graphql-new.gen";

export function OrderParcels({
  isFullDigital,
  orderId,
  parcels,
  shipping,
  tags,
}: {
  isFullDigital: boolean;
  orderId: string;
  parcels: OrderQuery["order"]["parcels"];
  shipping?: OrderQuery["order"]["shipping"];
  tags: OrderQuery["order"]["tags"];
}) {
  const { t } = useTranslation();

  if (isFullDigital) return null;

  if (parcels.length > 1) {
    return (
      <Accordion type="multiple" className="rounded border border-gray-300">
        {parcels.map((parcel, idx) => (
          <AccordionItem key={parcel.id} value={parcel.id}>
            <OrderMultiParcel
              index={idx}
              orderId={orderId}
              parcel={parcel}
              shipping={shipping}
            />
          </AccordionItem>
        ))}
        <div className="p-4">
          <div className="flex items-center space-x-1 text-sm">
            <span className="text-gray-700">
              {t("order.tracking.have_a_problem")}
            </span>

            <DialogPrimitive.Root modal={false}>
              <DialogPrimitive.Trigger asChild>
                <button type="button" className="font-semibold text-green-900">
                  {t("sidebar.contact_us")}
                </button>
              </DialogPrimitive.Trigger>
              <ContactUsDialog />
            </DialogPrimitive.Root>
          </div>
        </div>
      </Accordion>
    );
  }

  return (
    <OrderParcel
      orderId={orderId}
      parcel={parcels[0]}
      shipping={shipping}
      tags={tags}
    />
  );
}
